// extracted by mini-css-extract-plugin
module.exports = {"devices":"DeviceList_devices__1G-r5","device":"DeviceList_device__2jMK_","lsep":"DeviceList_lsep__2WvrJ"};